import { Record, Union } from "../fable-library-js.4.29.0/Types.js";
import { record_type, int32_type, union_type } from "../fable-library-js.4.29.0/Reflection.js";
import { reactApi } from "../Feliz.2.9.0/Interop.fs.js";
import { useEffectWithDeps } from "../Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "../Feliz.2.9.0/Internal.fs.js";
import { defaultArg } from "../fable-library-js.4.29.0/Option.js";

export class ScreenSize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Mobile", "MobileLandscape", "Tablet", "Desktop", "WideScreen"];
    }
}

export function ScreenSize_$reflection() {
    return union_type("Feliz.UseMediaQuery.ScreenSize", [], ScreenSize, () => [[], [], [], [], []]);
}

export class Breakpoints extends Record {
    constructor(MobileLandscape, Tablet, Desktop, WideScreen) {
        super();
        this.MobileLandscape = (MobileLandscape | 0);
        this.Tablet = (Tablet | 0);
        this.Desktop = (Desktop | 0);
        this.WideScreen = (WideScreen | 0);
    }
}

export function Breakpoints_$reflection() {
    return record_type("Feliz.UseMediaQuery.Breakpoints", [], Breakpoints, () => [["MobileLandscape", int32_type], ["Tablet", int32_type], ["Desktop", int32_type], ["WideScreen", int32_type]]);
}

export const BreakpointsModule_defaults = new Breakpoints(576, 768, 1024, 1216);

function makeQueries(breakpoints) {
    return [("(max-width: " + breakpoints.MobileLandscape) + "px)", ("(max-width: " + breakpoints.Tablet) + "px)", ("(max-width: " + breakpoints.Desktop) + "px)", ("(max-width: " + breakpoints.WideScreen) + "px)"];
}

/**
 * A hook for media queries, this hook will force a component
 * to re-render when the specified media query changes.
 */
export function useFeliz_React__React_useMediaQuery_Static_Z721C83C5(mediaQuery) {
    const patternInput = reactApi.useState(() => (window.matchMedia(mediaQuery)).matches);
    useEffectWithDeps(() => {
        const mediaQueryList = window.matchMedia(mediaQuery);
        const handler = () => {
            patternInput[1](mediaQueryList.matches);
        };
        handler();
        (mediaQueryList).addListener(handler);
        return createDisposable(() => {
            (mediaQueryList).removeListener(handler);
        });
    }, [mediaQuery]);
    return patternInput[0];
}

/**
 * A hook for responsive design, this hook will force a component
 * to re-render the components on resize.
 * Returns a discriminated union with the new width.
 */
export function useFeliz_React__React_useResponsive_Static_Z434A9929(breakpoints) {
    const patternInput = makeQueries(defaultArg(breakpoints, BreakpointsModule_defaults));
    const mx = useFeliz_React__React_useMediaQuery_Static_Z721C83C5(patternInput[0]);
    const lx = useFeliz_React__React_useMediaQuery_Static_Z721C83C5(patternInput[1]);
    const tx = useFeliz_React__React_useMediaQuery_Static_Z721C83C5(patternInput[2]);
    const dx = useFeliz_React__React_useMediaQuery_Static_Z721C83C5(patternInput[3]);
    if (mx) {
        return new ScreenSize(0, []);
    }
    else if (lx) {
        return new ScreenSize(1, []);
    }
    else if (tx) {
        return new ScreenSize(2, []);
    }
    else if (dx) {
        return new ScreenSize(3, []);
    }
    else {
        return new ScreenSize(4, []);
    }
}

//# sourceMappingURL=UseMediaQuery.fs.js.map
